/* zs.js: alle interactie van het thema. Geen dependencies. */
(() => {
  const Z = window.zs || {};
  const R = Z.routes || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  /* ---------- teksten in de taal van de klant (uit de taalbestanden, via theme.liquid) */
  const T = Z.t || {};
  const dec = (s) => { const e = document.createElement('textarea'); e.innerHTML = s; return e.value; };
  const tx = (k, fb) => (T[k] != null ? dec(T[k]) : fb);
  const addLabel = (q) => (q > 1 && T.addN && T.addN[q] ? dec(T.addN[q]) : tx('add', 'Add to bag'));
  const nItems = (n) => (T.items && T.items[n] ? dec(T.items[n]) : `${n} ${n === 1 ? 'item' : 'items'}`);

  /* ---------- geld: zelfde opmaak als Shopify in de valuta van de klant (voorbeeld 1234,56 uit Liquid) */
  const moneyLocal = (cents) => {
    const smp = Z.moneySample || '';
    const m = smp.match(/^(.*?)1(\D?)234(\D)56(.*)$/);
    const m0 = (Z.moneySampleNoDec || '').match(/^(.*?)1(\D?)234(\D*)$/);
    const n = (cents || 0) / 100;
    if (m) {
      const p = n.toFixed(2).split('.');
      return m[1] + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, m[2]) + m[3] + p[1] + m[4];
    }
    if (m0) return m0[1] + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, m0[2]) + m0[3];
    return null;
  };
  const money = (cents) => {
    const loc = moneyLocal(cents);
    if (loc != null) return loc;
    const fmt = Z.moneyFormat || '${{amount}}';
    const n = (cents || 0) / 100;
    const group = (num, dec, ts, ds) => {
      const p = num.toFixed(dec).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (dec ? ds + p[1] : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      switch (k) {
        case 'amount_no_decimals': return group(n, 0, ',', '.');
        case 'amount_with_comma_separator': return group(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(n, 2, "'", '.');
        case 'amount_with_space_separator': return group(n, 2, ' ', ',');
        default: return group(n, 2, ',', '.');
      }
    });
  };

  /* ---------- panelen (menu, cart, zoeken, filters) */
  const panels = {
    menu: () => $('#ZsMenu'),
    cart: () => $('[data-zs-cartd]'),
    search: () => $('[data-zs-sov]'),
    filters: () => $('[data-zs-fdrawer]'),
  };
  // panelen schuiven open en dicht via de class is-open (animatie in CSS)
  let lastFocus = null;
  let refocusing = false;
  const open = (name) => {
    const el = panels[name] && panels[name]();
    if (!el) return false;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const f = name === 'search' ? $('[data-zs-q]', el) : $('[data-zs-close]:not(.shade), a, button, input', el);
    if (f) setTimeout(() => f.focus({ preventScroll: true }), 60);
    return true;
  };
  const closeAll = () => {
    let any = false;
    Object.values(panels).forEach((fn) => {
      const el = fn();
      if (el && el.classList.contains('is-open')) { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); any = true; }
    });
    document.documentElement.style.overflow = '';
    if (any && lastFocus && lastFocus.focus) {
      // focus terug naar de knop/zoekbalk zonder het zoekvenster opnieuw te openen
      refocusing = true;
      lastFocus.focus({ preventScroll: true });
      refocusing = false;
    }
  };
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-zs-open]');
    if (o) {
      const name = o.dataset.zsOpen;
      if (name === 'cart' && Z.cartType === 'page') return;
      if (o.tagName === 'FORM') return;
      if (open(name)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-zs-close]')) { e.preventDefault(); closeAll(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
  // zoekbalk in de header opent het zoekvenster
  $$('form.sbar-h').forEach((f) => {
    const inp = $('input[name="q"]', f);
    const go = () => {
      if (refocusing) return;
      if (!open('search')) return;
      const q = $('[data-zs-q]');
      if (q && inp.value) { q.value = inp.value; q.dispatchEvent(new Event('input')); }
    };
    inp.addEventListener('focus', go);
    inp.addEventListener('click', go);
    f.addEventListener('submit', (e) => { e.preventDefault(); go(); });
  });

  /* ---------- aankondigingsbalk: op mobiel wisselen de berichten elkaar af */
  $$('[data-zs-ann]').forEach((bar) => {
    const items = $$('.ann-m', bar);
    if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('on');
      i = (i + 1) % items.length;
      items[i].classList.add('on');
    }, 4000);
  });

  /* ---------- winkelwagen */
  const json = (url, body) =>
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(async (r) => { const d = await r.json(); if (!r.ok) throw d; return d; });

  // cart-HTML vervangen zonder dat de lade knippert of van scrollpositie springt
  const cartIds = () => {
    const page = $('[data-zs-cart-page]');
    const ids = ['cart-drawer'];
    if (page) ids.push(page.dataset.section);
    return ids;
  };
  const swapInner = (host, html) => {
    if (!host || !html) return;
    const n = $('[data-zs-cart-inner]', parse(html));
    const inner = host.matches('[data-zs-cart-inner]') ? host : $('[data-zs-cart-inner]', host);
    if (!n || !inner) return;
    const body = $('.d-body', inner);
    const top = body ? body.scrollTop : 0;
    const hadFocus = inner.contains(document.activeElement);
    inner.innerHTML = n.innerHTML;
    const nb = $('.d-body', inner);
    if (nb) nb.scrollTop = top;
    // focus blijft in de lade (toetsenbord en schermlezers)
    if (hadFocus) { const c = $('[data-zs-close]', inner); if (c) c.focus({ preventScroll: true }); }
  };
  const setCount = (count) => {
    $$('[data-zs-count]').forEach((b) => { b.textContent = count; b.hidden = count === 0; });
  };
  const applySections = (sections) => {
    if (!sections) return;
    const page = $('[data-zs-cart-page]');
    const dh = sections['cart-drawer'];
    swapInner($('[data-zs-cartd]'), dh);
    if (page) swapInner(page, sections[page.dataset.section]);
    // aantal komt mee in de drawer-HTML, dus geen extra verzoek nodig
    const c = dh && $('[data-zs-cart-inner]', parse(dh));
    if (c && c.dataset.count !== undefined) setCount(Number(c.dataset.count));
    initUpsells();
  };
  const refreshCart = async () => {
    const ids = cartIds();
    const [res, cart] = await Promise.all([
      fetch(`${R.root}?sections=${ids.join(',')}`).then((r) => r.json()),
      fetch(`${R.cart}.js`).then((r) => r.json()),
    ]);
    applySections(res);
    setCount(cart.item_count);
    return cart;
  };
  // de lade schuift al open terwijl het verzoek loopt, dus geen dode tijd na de klik
  const addItems = async (items) => {
    const drawer = Z.cartType !== 'page' && $('[data-zs-cartd]');
    const inner = drawer && $('[data-zs-cart-inner]', drawer);
    if (inner) { inner.classList.add('is-adding'); open('cart'); }
    try {
      const r = await json(`${R.cartAdd}.js`, { items, sections: cartIds(), sections_url: location.pathname });
      if (!drawer) { window.location.href = R.cart; return; }
      if (r.sections && r.sections['cart-drawer']) applySections(r.sections);
      else await refreshCart();
    } catch (err) {
      if (drawer) closeAll();
      throw err;
    } finally {
      if (inner) inner.classList.remove('is-adding');
    }
  };
  let cartBusy = false;
  document.addEventListener('click', async (e) => {
    const line = e.target.closest('[data-zs-line]');
    if (line) {
      e.preventDefault();
      if (cartBusy) return;
      cartBusy = true;
      const box = line.closest('[data-zs-cart-inner]');
      const row = line.closest('.line');
      box && box.classList.add('is-loading');
      row && row.classList.add('is-updating');
      try {
        const r = await json(`${R.cartChange}.js`, { id: line.dataset.zsLine, quantity: Number(line.dataset.q), sections: cartIds(), sections_url: location.pathname });
        applySections(r.sections);
        setCount(r.item_count);
      } catch (err) {
        // bv. voorraadlimiet: toon de echte stand van de cart
        try { await refreshCart(); } catch (x) { /* offline */ }
      }
      const nbox = $$('[data-zs-cart-inner].is-loading');
      nbox.forEach((x) => x.classList.remove('is-loading'));
      $$('.line.is-updating').forEach((x) => x.classList.remove('is-updating'));
      cartBusy = false;
      return;
    }
    const add = e.target.closest('[data-zs-add]');
    if (add) {
      e.preventDefault();
      if (cartBusy) return;
      cartBusy = true;
      add.classList.add('zs-busy');
      try {
        const r = await json(`${R.cartAdd}.js`, { items: [{ id: Number(add.dataset.zsAdd), quantity: 1 }], sections: cartIds(), sections_url: location.pathname });
        applySections(r.sections);
      } catch (err) {
        try { await refreshCart(); } catch (x) { /* offline */ }
      }
      add.classList.remove('zs-busy');
      cartBusy = false;
      return;
    }
    const back = e.target.closest('[data-zs-back]');
    if (back && document.referrer && new URL(document.referrer).origin === location.origin && !document.referrer.includes('/cart')) {
      e.preventDefault();
      history.back();
    }
  });

  // upsell-carrousel met pijltjes
  const initUpsells = () => {
    $$('[data-zs-ups]').forEach((u) => {
      if (u.dataset.ready) return;
      u.dataset.ready = '1';
      const row = $('.ups-row', u);
      const [prev, next] = $$('[data-zs-ups-dir]', u);
      const sync = () => {
        prev.disabled = row.scrollLeft <= 2;
        next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
      };
      $$('[data-zs-ups-dir]', u).forEach((b) => b.addEventListener('click', () => {
        const card = $('.up', row);
        const step = card ? card.getBoundingClientRect().width + 12 : row.clientWidth;
        row.scrollBy({ left: step * Number(b.dataset.zsUpsDir), behavior: 'smooth' });
      }));
      row.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
      sync();
    });
  };
  initUpsells();

  /* ---------- productpagina */
  class ZsProduct extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse($('[data-zs-json]', this).textContent);
      this.form = $('[data-zs-form]', this);
      this.idInput = $('[data-zs-id]', this);
      this.atc = $('[data-zs-atc]', this);
      this.err = $('[data-zs-err]', this);
      this.track = $('[data-zs-track]', this);
      this.thumbs = $('[data-zs-thumbs]', this);
      this.sticky = $('[data-zs-sticky]', this);

      $$('[data-zs-opt]', this).forEach((g) => g.addEventListener('click', (e) => {
        const b = e.target.closest('[data-value]');
        if (!b) return;
        $$('[data-value]', g).forEach((x) => { x.classList.toggle('on', x === b); x.setAttribute('aria-checked', x === b); });
        $('[data-zs-optval]', g).textContent = b.dataset.value;
        this.update();
      }));

      $$('[data-zs-qty]', this).forEach((b) => b.addEventListener('click', () => {
        const i = $('.qty-n', this);
        i.value = Math.max(1, (parseInt(i.value, 10) || 1) + Number(b.dataset.zsQty));
        this.atcLabel();
      }));
      const qn = $('.qty-n', this);
      if (qn) qn.addEventListener('input', () => this.atcLabel());
      this.addEventListener('zs:qty', () => this.atcLabel());
      this.variant = this.data.variants.find((x) => String(x.id) === String(this.idInput && this.idInput.value));

      if (this.form) this.form.addEventListener('submit', (e) => { e.preventDefault(); this.add(); });
      this.bdl = $('[data-zs-bdl]', this);
      if (this.bdl) this.initBundle();

      if (this.track) {
        if (this.thumbs) $$('[data-media]', this.thumbs).forEach((t, i) => t.addEventListener('click', () => this.go(i)));
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.mark(Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth))));
        }, { passive: true });
        const on = this.thumbs && $('.on', this.thumbs);
        if (on) this.go($$('[data-media]', this.thumbs).indexOf(on), false);
      }

      if (this.sticky && this.atc) {
        const sb = $('[data-zs-sb-atc]', this.sticky);
        sb && sb.addEventListener('click', () => this.form.requestSubmit());
        let tick = false;
        const sync = () => {
          tick = false;
          const past = this.atc.getBoundingClientRect().bottom < 0;
          this.sticky.classList.toggle('is-on', past);
          this.sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
          sb && sb.setAttribute('tabindex', past ? '0' : '-1');
        };
        // ruimte onder de footer ter hoogte van de balk, zodat de hele footer erboven zichtbaar blijft
        const room = () => { document.body.style.paddingBottom = `${this.sticky.offsetHeight}px`; };
        const req = () => { if (!tick) { tick = true; requestAnimationFrame(sync); } };
        window.addEventListener('scroll', req, { passive: true });
        window.addEventListener('resize', () => { room(); req(); });
        room();
        sync();
      }
      this.markAvailability();
    }
    selected() {
      return $$('[data-zs-opt]', this).map((g) => { const b = $('[data-value].on', g); return b ? b.dataset.value : null; });
    }
    find(opts) {
      return this.data.variants.find((v) => v.options.every((o, i) => opts[i] === null || o === opts[i]));
    }
    markAvailability() {
      const sel = this.selected();
      $$('[data-zs-opt]', this).forEach((g, i) => {
        $$('[data-value]', g).forEach((b) => {
          const test = sel.slice(); test[i] = b.dataset.value;
          const v = this.data.variants.find((x) => x.options.every((o, k) => o === test[k]));
          b.classList.toggle('off', !v || !v.available);
        });
      });
    }
    update() {
      const v = this.find(this.selected());
      this.markAvailability();
      if (this.err) this.err.hidden = true;
      if (!v) { this.setAtc(false, tx('soldOut', 'Sold out')); return; }
      this.variant = v;
      this.idInput.value = v.id;
      const p = $('[data-zs-price]', this);
      if (p) {
        let h = `<span>${money(v.price)}</span>`;
        if (v.compare_at_price > v.price) {
          const pct = Math.floor(((v.compare_at_price - v.price) * 100) / v.compare_at_price);
          h += `<s>${money(v.compare_at_price)}</s>` + (pct > 0 ? `<span class="save">${tx('savePct', 'Save %p%').replace('%p', pct)}</span>` : '');
        }
        p.innerHTML = h;
      }
      const sb = $('[data-zs-sale-badge]', this.closest('.pdp') || document);
      if (sb) sb.hidden = !(v.compare_at_price > v.price);
      this.setAtc(v.available, v.available ? tx('add', 'Add to bag') : tx('soldOut', 'Sold out'));
      this.atcLabel();
      this.dispatchEvent(new CustomEvent('zs:variant', { detail: v, bubbles: true }));
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
      if (v.featured_media && this.thumbs) {
        const i = $$('[data-media]', this.thumbs).findIndex((t) => t.dataset.media == v.featured_media.id);
        if (i > -1) this.go(i);
      }
      if (this.sticky) {
        const sv = $('[data-zs-sb-var]', this.sticky); if (sv) sv.textContent = v.title;
        const sp = $('[data-zs-sb-price]', this.sticky); if (sp) sp.textContent = money(v.price);
        const si = $('[data-zs-sb-img] img', this.sticky);
        if (si && v.featured_image) { si.src = v.featured_image.src; si.removeAttribute('srcset'); }
      }
    }
    setAtc(ok, label) {
      [this.atc, this.sticky && $('[data-zs-sb-atc]', this.sticky)].forEach((b) => {
        if (!b) return;
        b.disabled = !ok;
        b.textContent = label;
      });
    }
    /* bundelstijl: aantal kiezen en per stuk een kleur en/of maat. Werkt ook zonder varianten. */
    initBundle() {
      const b = this.bdl;
      const tiers = $$('.bdl-t', b);
      const more = $('.bdl-more', b);
      const link = $('[data-zs-bmore]', b);
      const pick = (t) => {
        tiers.forEach((x) => { x.classList.toggle('on', x === t); const h = $('.bdl-h', x); if (h && h.tagName === 'BUTTON') h.setAttribute('aria-pressed', x === t); });
        if (more) { more.hidden = t !== more; if (link) link.hidden = t === more; }
        const bv = $('[data-zs-bval]', b);
        if (bv) { const q = Number(t.dataset.q); bv.textContent = this.bName(q); }
        this.bundleSync(true);
      };
      tiers.forEach((t) => { const h = $('.bdl-h', t); if (h && t !== more) h.addEventListener('click', () => pick(t)); });
      if (link && more) link.addEventListener('click', () => pick(more));
      if (more) {
        const max = Number(b.dataset.max) || 10;
        const min = Number(more.dataset.min) || 2;
        const box = $('.bdl-items', more);
        $$('[data-zs-mstep]', more).forEach((btn) => btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const cur = Number(more.dataset.q);
          const q = Math.min(max, Math.max(min, cur + Number(btn.dataset.zsMstep)));
          if (q === cur) return;
          let items = $$('[data-zs-item]', more);
          while (items.length < q) {
            const c = items[items.length - 1].cloneNode(true);
            const n = items.length + 1;
            const num = $('.bdl-i', c); if (num) num.textContent = n;
            $$('[aria-label]', c).forEach((el) => { if (el.matches('.bdl-sw, .bdl-sel')) el.setAttribute('aria-label', el.getAttribute('aria-label').replace(/\d+$/, n)); });
            box.appendChild(c);
            this.bindItem(c);
            items = $$('[data-zs-item]', more);
          }
          while (items.length > q) { items.pop().remove(); }
          more.dataset.q = q;
          $('[data-zs-mval]', more).textContent = q;
          $('[data-zs-mname]', more).textContent = this.bName(q);
          this.bundleSync(false);
        }));
      }
      $$('[data-zs-item]', b).forEach((it) => this.bindItem(it));
      this.bundleSync(false);
    }
    bName(q) {
      let names = [];
      try { names = JSON.parse(this.bdl.dataset.names || '[]'); } catch (e) { names = []; }
      return names[q] ? dec(names[q]) : `${q}`;
    }
    bindItem(it) {
      const b = this.bdl;
      const isOn = () => it === $('.bdl-t.on [data-zs-item]', b);
      it.addEventListener('click', (e) => {
        const w = e.target.closest('.bdl-w');
        if (!w) return;
        const g = w.parentElement;
        $$('.bdl-w', g).forEach((x) => { x.classList.toggle('on', x === w); x.setAttribute('aria-checked', x === w); });
        const cn = $('[data-zs-cn]', it); if (cn) cn.textContent = w.dataset.value;
        this.bundleSync(isOn());
      });
      $$('.bdl-sel', it).forEach((sel) => sel.addEventListener('change', () => this.bundleSync(isOn())));
    }
    itemVariant(it) {
      const opts = this.data.options.map((_, i) => {
        const sw = $(`.bdl-sw[data-opt="${i}"] .bdl-w.on`, it);
        if (sw) return sw.dataset.value;
        const sel = $(`.bdl-sel[data-opt="${i}"]`, it);
        return sel ? sel.value : null;
      });
      return this.data.variants.find((v) => v.options.every((o, i) => opts[i] === null || o === opts[i]));
    }
    bundleSync(moveGallery) {
      const b = this.bdl;
      let ok = true, now = 0, q = 1, first = null, cmp = 0;
      $$('.bdl-t', b).forEach((t) => {
        const pct = Number(t.dataset.pct) || 0;
        let full = 0, tOk = true;
        let fullCmp = 0;
        $$('[data-zs-item]', t).forEach((it, k) => {
          const v = this.itemVariant(it);
          const bad = !v || !v.available;
          it.classList.toggle('off', bad);
          if (bad) tOk = false;
          full += v ? v.price : 0;
          fullCmp += v ? Math.max(v.price, v.compare_at_price || 0) : 0;
          if (k === 0 && t.classList.contains('on')) first = v;
        });
        const tNow = Math.round(full * (100 - pct) / 100);
        $('[data-zs-bnow]', t).textContent = money(tNow);
        const was = $('[data-zs-bwas]', t); if (was) was.textContent = money(full);
        const sv = $('[data-zs-bsave]', t); if (sv && b.dataset.save === 'amount') sv.textContent = tx('saveAmt', 'Save %a').replace('%a', money(full - tNow));
        const fr = $('[data-zs-bfree]', t); const fc = Number(b.dataset.free);
        if (fr) fr.hidden = !(fc >= 0 && tNow >= fc);
        if (t.classList.contains('on')) { ok = tOk; now = tNow; q = Number(t.dataset.q); cmp = fullCmp; }
      });
      if (first) {
        this.variant = first;
        if (this.idInput) this.idInput.value = first.id;
        if (moveGallery && first.featured_media && this.thumbs) {
          const i = $$('[data-media]', this.thumbs).findIndex((t) => t.dataset.media == first.featured_media.id);
          if (i > -1) this.go(i);
        }
      }
      // prijs onder de titel volgt de gekozen bundel (doorgestreept = normale prijs van dat aantal)
      if (first) this.dispatchEvent(new CustomEvent('zs:bprice', { bubbles: true, detail: { price: now, compare_at_price: cmp > now ? cmp : 0 } }));
      if (!this.atc) return;
      this.atc.disabled = !ok;
      const sb = this.sticky && $('[data-zs-sb-atc]', this.sticky);
      if (sb) sb.disabled = !ok;
      if (!ok) { this.atc.textContent = tx('soldOut', 'Sold out'); return; }
      const lab = addLabel(q);
      this.atc.innerHTML = `<span>${lab}</span><span class="atc-sep">·</span><span>${money(now)}</span>`;
      if (sb) sb.textContent = lab;
    }
    bundleItems() {
      const m = new Map();
      $$('.bdl-t.on [data-zs-item]', this.bdl).forEach((it) => {
        const v = this.itemVariant(it);
        if (v) m.set(v.id, (m.get(v.id) || 0) + 1);
      });
      return [...m].map(([id, quantity]) => ({ id, quantity }));
    }
    // hoofdknop toont het echte bedrag: prijs x aantal, met bundelkorting als die gekozen is
    atcLabel() {
      if (this.bdl) { this.bundleSync(false); return; }
      const v = this.variant;
      if (!this.atc || !v || !v.available) return;
      const qn = $('.qty-n', this);
      const q = Math.max(1, parseInt(qn && qn.value, 10) || 1);
      const bd = $('[data-zs-bundle] .bd.on', this);
      const pct = bd ? Number(bd.dataset.pct) || 0 : 0;
      const full = v.price * q;
      const now = pct > 0 ? Math.round(full * (100 - pct) / 100) : full;
      this.atc.innerHTML = `<span>${tx('add', 'Add to bag')}</span><span class="atc-sep">·</span><span>${money(now)}</span>`;
    }
    async add() {
      const fd = new FormData(this.form);
      this.atc.classList.add('is-busy');
      try {
        await addItems(this.bdl ? this.bundleItems() : [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 }]);
      } catch (err) {
        if (this.err) { this.err.textContent = err.description || err.message || tx('err', 'Could not add to cart.'); this.err.hidden = false; }
      }
      this.atc.classList.remove('is-busy');
    }
    go(i, smooth = true) {
      const slides = this.track.children;
      if (!slides[i]) return;
      this.track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      this.mark(i);
    }
    mark(i) {
      if (!this.thumbs) return;
      const ts = $$('[data-media]', this.thumbs);
      ts.forEach((t, k) => t.classList.toggle('on', k === i));
      const t = ts[i];
      if (!t) return;
      const box = this.thumbs;
      if (t.offsetLeft < box.scrollLeft || t.offsetLeft + t.offsetWidth > box.scrollLeft + box.clientWidth) {
        box.scrollTo({ left: t.offsetLeft - box.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
      }
    }
  }
  if (!customElements.get('zs-product')) customElements.define('zs-product', ZsProduct);

  /* ---------- aanbevolen producten */
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        const io = new IntersectionObserver(async ([en]) => {
          if (!en.isIntersecting) return;
          io.disconnect();
          const html = await fetch(this.dataset.url).then((r) => r.text());
          const n = $('product-recommendations', parse(html));
          if (n && n.innerHTML.trim()) this.innerHTML = n.innerHTML;
        }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(this);
      }
    });
  }

  /* ---------- zoeken */
  const sov = $('[data-zs-sov]');
  if (sov) {
    const q = $('[data-zs-q]', sov);
    const out = $('[data-zs-sres]', sov);
    const clr = $('[data-zs-clear]', sov);
    let t, ctl;
    q.addEventListener('input', () => {
      clearTimeout(t);
      clr.hidden = !q.value;
      t = setTimeout(async () => {
        const term = q.value.trim();
        if (!term) { out.innerHTML = ''; return; }
        ctl && ctl.abort();
        ctl = new AbortController();
        try {
          const html = await fetch(`${R.search}?q=${encodeURIComponent(term)}&resources[type]=product,collection,query&resources[limit]=4&resources[limit_scope]=each&section_id=predictive-search`, { signal: ctl.signal }).then((r) => r.text());
          const d = parse(html);
          const sec = d.querySelector('.shopify-section') || d.body;
          out.innerHTML = sec.innerHTML;
        } catch (e) { /* afgebroken */ }
      }, 200);
    });
    clr.addEventListener('click', () => { q.value = ''; clr.hidden = true; out.innerHTML = ''; q.focus(); });
  }

  /* ---------- filters, sorteren, meer laden */
  $$('[data-zs-filters]').forEach((f) => {
    const go = () => {
      const p = new URLSearchParams(new FormData(f));
      for (const [k, v] of Array.from(p.entries())) if (v === '') p.delete(k);
      location.href = `${location.pathname}?${p.toString()}`;
    };
    f.addEventListener('change', go);
    f.addEventListener('submit', (e) => { e.preventDefault(); go(); });
  });
  $$('[data-zs-sort]').forEach((s) => s.addEventListener('change', () => {
    const u = new URL(location.href);
    u.searchParams.set('sort_by', s.value);
    u.searchParams.delete('page');
    location.href = u.toString();
  }));
  document.addEventListener('click', async (e) => {
    const m = e.target.closest('[data-zs-more]');
    if (!m) return;
    e.preventDefault();
    m.classList.add('is-busy');
    const d = parse(await fetch(m.href).then((r) => r.text()));
    const grid = $('[data-zs-grid]');
    const ng = $('[data-zs-grid]', d);
    if (grid && ng) grid.append(...Array.from(ng.children));
    ['[data-zs-shown]', '[data-zs-bar]'].forEach((s) => { const a = $(s), b = $(s, d); if (a && b) { a.textContent = b.textContent; a.style.width = b.style.width; } });
    const nm = $('[data-zs-more]', d);
    if (nm) { m.href = nm.href; m.classList.remove('is-busy'); } else m.remove();
  });

  /* ---------- FAQ-tabs */
  $$('[data-zs-faq]').forEach((f) => {
    $$('.fq-tabs a', f).forEach((a) => a.addEventListener('click', (e) => {
      e.preventDefault();
      $$('.fq-tabs a', f).forEach((x) => x.classList.toggle('on', x === a));
      $$('.fq-group', f).forEach((g) => { g.hidden = !!a.dataset.g && g.dataset.g !== a.dataset.g; });
    }));
  });
  /* ---------- extra productblokken en -secties */
  const pad = (n) => String(n).padStart(2, '0');
  const curVariant = () => {
    const el = $('zs-product');
    if (!el || !el.data) return null;
    const id = Number(($('[data-zs-id]', el) || {}).value);
    return el.data.variants.find((v) => v.id === id) || el.data.variants[0];
  };

  // sale timer: alleen tot de echte einddatum, daarna verdwijnt hij
  $$('[data-zs-sale]').forEach((t) => {
    const raw = t.dataset.zsSale.trim().replace(' ', 'T');
    const end = new Date(raw);
    if (isNaN(end)) return;
    const cd = $('[data-zs-cd]', t);
    const onlySale = t.dataset.onlySale === 'true';
    const tick = () => {
      const ms = end - new Date();
      const v = curVariant();
      const onSale = !v || v.compare_at_price > v.price;
      if (ms <= 0 || (onlySale && !onSale)) { t.hidden = true; return ms > 0; }
      const d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60, sec = Math.floor(ms / 1e3) % 60;
      cd.innerHTML = (d ? `<b>${d}</b>${tx('d', 'd')} ` : '') + `<b>${pad(h)}</b>${tx('h', 'h')} <b>${pad(m)}</b>${tx('m', 'm')}` + (d ? '' : ` <b>${pad(sec)}</b>${tx('s', 's')}`);
      t.hidden = false;
      return true;
    };
    if (tick()) { const iv = setInterval(() => { if (!tick() && end - new Date() <= 0) clearInterval(iv); }, 1000); }
    document.addEventListener('zs:variant', tick);
  });

  // bundel: aantal kiezen, prijzen volgen de gekozen variant
  $$('[data-zs-bundle]').forEach((b) => {
    const pdp = b.closest('zs-product');
    const qty = pdp && $('[data-zs-bqty]', pdp);
    const opts = $$('.bd', b);
    const pick = (o) => {
      opts.forEach((x) => { x.classList.toggle('on', x === o); x.setAttribute('aria-checked', x === o); });
      if (qty) qty.value = o.dataset.q;
      if (pdp) pdp.dispatchEvent(new CustomEvent('zs:qty'));
    };
    const prices = () => {
      const v = curVariant();
      if (!v) return;
      opts.forEach((o) => {
        const q = Number(o.dataset.q), pct = Number(o.dataset.pct);
        const full = v.price * q, now = Math.round(full * (100 - pct) / 100);
        $('[data-zs-bnow]', o).textContent = money(now);
        const was = $('[data-zs-bwas]', o); if (was) was.textContent = money(full);
        if (pct > 0) $('[data-zs-bsub]', o).textContent = tx('youSave', 'You save %a').replace('%a', money(full - now));
      });
    };
    opts.forEach((o) => o.addEventListener('click', () => pick(o)));
    const on = $('.bd.on', b) || opts[0];
    if (on) pick(on);
    document.addEventListener('zs:variant', prices);
  });

  // lage voorraad: echte voorraad per variant
  $$('[data-zs-stock]').forEach((s) => {
    let map = {};
    try { map = JSON.parse($('script', s).textContent); } catch (e) { /* leeg */ }
    const lim = Number(s.dataset.zsStock);
    const show = () => {
      const v = curVariant();
      const q = v ? map[v.id] : undefined;
      const ok = typeof q === 'number' && q > 0 && q <= lim;
      s.hidden = !ok;
      if (ok) $('[data-zs-stock-t]', s).innerHTML = s.dataset.text.replace('[count]', `<b>${q}</b>`);
    };
    show();
    document.addEventListener('zs:variant', show);
  });

  // levertijd: werkdagen, cutoff en marge uit de instellingen
  $$('[data-zs-dlv]').forEach((d) => {
    const cut = Number(d.dataset.cutoff), proc = Number(d.dataset.proc), tmin = Number(d.dataset.min), tmax = Math.max(Number(d.dataset.max), Number(d.dataset.min));
    const wk = d.dataset.wk === 'true';
    const isWork = (x) => wk || (x.getDay() !== 0 && x.getDay() !== 6);
    const addDays = (x, n) => { const r = new Date(x); let k = n; while (k > 0) { r.setDate(r.getDate() + 1); if (isWork(r)) k -= 1; } return r; };
    const nextWork = (x) => { const r = new Date(x); while (!isWork(r)) r.setDate(r.getDate() + 1); return r; };
    const lang = document.documentElement.lang || 'en';
    const fmt = (x) => x.toLocaleDateString(lang, { weekday: 'short', day: 'numeric', month: 'short' });
    const fmtd = (x) => x.toLocaleDateString(lang, { day: 'numeric', month: 'short' });
    const run = () => {
      const now = new Date();
      let ship = new Date(now);
      const today = isWork(now) && now.getHours() < cut;
      if (!today) { ship.setDate(ship.getDate() + 1); ship = nextWork(ship); }
      ship = addDays(ship, proc);
      const a = addDays(ship, tmin), b = addDays(ship, tmax);
      const h = $('[data-zs-dlv-h]', d);
      if (today && proc === 0) {
        const left = new Date(now); left.setHours(cut, 0, 0, 0);
        const ms = left - now, hh = Math.floor(ms / 36e5), mm = Math.floor(ms / 6e4) % 60;
        h.innerHTML = tx('orderWithin', 'Order within <b>%t</b> and it ships today').replace('%t', tx('hm', '%hh %mm').replace('%h', hh).replace('%m', pad(mm)));
      } else {
        h.innerHTML = tx('orderNow', 'Order now and it ships <b>%d</b>').replace('%d', fmt(ship));
      }
      $('[data-zs-d1]', d).textContent = fmt(now);
      $('[data-zs-d2]', d).textContent = fmt(ship);
      $('[data-zs-d3]', d).textContent = tmin === tmax ? fmt(a) : tx('range', '%f to %t').replace('%f', fmtd(a)).replace('%t', fmtd(b));
      d.hidden = false;
    };
    run();
    setInterval(run, 30000);
  });

  // knop in een sectie scrollt naar Add to cart
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-zs-to-atc]');
    if (!t) return;
    const f = $('[data-zs-form]');
    if (f) f.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  // voor en na: slepen of pijltjes
  $$('[data-zs-ba]').forEach((el) => {
    const set = (p) => { p = Math.max(0, Math.min(100, p)); el.style.setProperty('--ba', p + '%'); el.setAttribute('aria-valuenow', Math.round(p)); };
    const at = (x) => { const r = el.getBoundingClientRect(); set(((x - r.left) / r.width) * 100); };
    let drag = false;
    el.addEventListener('pointerdown', (e) => { drag = true; el.setPointerCapture(e.pointerId); at(e.clientX); });
    el.addEventListener('pointermove', (e) => { if (drag) at(e.clientX); });
    el.addEventListener('pointerup', () => { drag = false; });
    el.addEventListener('keydown', (e) => {
      const cur = parseFloat(el.style.getPropertyValue('--ba')) || 50;
      if (e.key === 'ArrowLeft') { set(cur - 5); e.preventDefault(); }
      if (e.key === 'ArrowRight') { set(cur + 5); e.preventDefault(); }
    });
  });

  // reviews: meer laden
  $$('[data-zs-rv-more]').forEach((btn) => btn.addEventListener('click', () => {
    const list = btn.closest('section').querySelector('[data-zs-rv]');
    const per = Number(list.dataset.zsRv) || 4;
    const hid = $$('.rvc[hidden]', list);
    hid.slice(0, per).forEach((x) => { x.hidden = false; });
    if (hid.length <= per) btn.parentElement.hidden = true;
  }));

  // vaak samen gekocht
  $$('[data-zs-fbt]').forEach((f) => {
    const pct = Number(f.dataset.pct) || 0;
    const boxes = $$('input[type=checkbox]', f);
    const self = $('[data-self]', f);
    const sum = () => {
      const on = boxes.filter((b) => b.checked);
      const tot = on.reduce((a, b) => a + Number(b.dataset.price), 0);
      const disc = Math.round(tot * (100 - pct) / 100);
      $('[data-zs-fbt-n]', f).textContent = nItems(on.length);
      $('[data-zs-fbt-sub]', f).textContent = money(tot);
      const was = $('[data-zs-fbt-was]', f);
      if (was) was.textContent = pct > 0 && on.length > 1 ? money(tot) : '';
      $('[data-zs-fbt-tot]', f).textContent = money(pct > 0 && on.length > 1 ? disc : tot);
      $('[data-zs-fbt-add]', f).disabled = on.length === 0;
    };
    boxes.forEach((b) => b.addEventListener('change', sum));
    document.addEventListener('zs:variant', (e) => {
      if (!self || !e.detail) return;
      self.dataset.id = e.detail.id; self.dataset.price = e.detail.price;
      self.disabled = !e.detail.available; if (!e.detail.available) self.checked = false;
      const em = self.parentElement.querySelector('em'); if (em) em.textContent = money(e.detail.price);
      sum();
    });
    $('[data-zs-fbt-add]', f).addEventListener('click', async (e) => {
      const btn = e.currentTarget, err = $('[data-zs-fbt-err]', f);
      const items = boxes.filter((b) => b.checked && !b.disabled).map((b) => ({ id: Number(b.dataset.id), quantity: 1 }));
      if (!items.length) return;
      btn.classList.add('is-busy'); err.hidden = true;
      try { await addItems(items); } catch (x) { err.textContent = x.description || x.message || tx('err', 'Could not add to cart.'); err.hidden = false; }
      btn.classList.remove('is-busy');
    });
    sum();
  });

  // recent bekeken: bewaard in deze browser
  (() => {
    const KEY = 'zs_recent';
    let list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
    const meEl = $('[data-zs-recent-me]');
    let me = null;
    if (meEl) { try { me = JSON.parse(meEl.textContent); } catch (e) { me = null; } }
    $$('[data-zs-recent]').forEach((sec) => {
      const max = Number(sec.dataset.zsRecent) || 6;
      const items = list.filter((x) => !me || x.h !== me.h).slice(0, max);
      if (!items.length) return;
      const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      $('[data-zs-recent-list]', sec).innerHTML = items.map((x) => `<a href="${esc(x.u)}" class="card"><div class="ph">${x.i ? `<img src="${esc(x.i)}" alt="" loading="lazy">` : ''}</div><div class="card-info"><span class="card-name">${esc(x.t)}</span><span class="price"><span>${esc(x.p)}</span></span></div></a>`).join('');
      sec.hidden = false;
    });
    if (me) {
      list = [me].concat(list.filter((x) => x.h !== me.h)).slice(0, 12);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* privémodus */ }
    }
  })();
})();

/* productpagina: secties onder de productinfo om en om wit en lichtgrijs (alleen secties die echt iets tonen) */
(() => {
  const run = () => {
    if (!document.body.classList.contains('pt-product')) return;
    let k = 0;
    document.querySelectorAll('main > .shopify-section').forEach((s, i) => {
      s.classList.remove('mk-alt', 'mk-sec');
      if (i === 0 || s.offsetHeight === 0) return;
      s.classList.add('mk-sec');
      k += 1;
      if (k % 2 === 1) s.classList.add('mk-alt');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  // secties die later vullen (bv. You may also like) tellen ook mee
  let q = 0;
  const later = () => { cancelAnimationFrame(q); q = requestAnimationFrame(run); };
  const main = document.querySelector('main');
  if (main && 'ResizeObserver' in window) { const ro = new ResizeObserver(later); main.querySelectorAll(':scope > .shopify-section').forEach((s) => ro.observe(s)); }
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:unload', () => setTimeout(run, 0));
  document.addEventListener('shopify:section:reorder', run);
})();
